import React from "react";
import "tailwindcss/tailwind.css";

export const Checkbox = ({
  label,
  checked,
  onChange,
  labelClassName = "text-xs sm:text-base text-gray-900 dark:text-gray-100",
}) => {
  return (
    <label className="flex items-center">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="rounded text-primary focus:ring-primary"
      />
      <span className={`ml-2 ${labelClassName}`}>{label}</span>
    </label>
  );
};
